import "@scss/main.scss";
import initializeAllSwipers from "./modules/set-swiper";
import { handlePopupOnScroll } from "./modules/popup";
import { setSubMenuWidth, toggleMobileSubMenu } from "./modules/menu";
import { navigateToContent } from "./modules/accessibility";
import toggleAdvancedSearch from "./modules/search";
import { hideHeaderNavAndLogo } from "./modules/sticky-menu";
import { togglePlayPause, audioBlocks } from "./modules/play-audio";
import { hideExtraSectionIfOdd } from "./modules/extra-footer.js";
import { setFallbackColor } from "./modules/fallbackColor";
import { dynamicGap } from "./modules/dynamicGap.js";

window.addEventListener("DOMContentLoaded", () => {
    console.warn("JS running from WebPack");

    initializeAllSwipers();
    handlePopupOnScroll();
    toggleMobileSubMenu();
    navigateToContent();
    toggleAdvancedSearch();
    hideHeaderNavAndLogo();
    togglePlayPause("play-btn", "pause-btn");
    hideExtraSectionIfOdd();
    setFallbackColor(
        "--wp--book-color",
        "var(--wp--preset--color--custom-loomingu-raamatukogu-hall)"
    );
    dynamicGap();
    audioBlocks();

});

// window.addEventListener("load", setSubMenuWidth);



